import { BASEURL } from "config";
import { Container } from "@mui/material";
import { toast } from "react-hot-toast";
import React, { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";

import "./homePage.scss";

const Queries = () => {
  const recaptchaRef = React.createRef();
  const initialFormData = {
    email: "",
    name: "",
    query: "",
    phone: "",
    captcha: "",
  };
  const [formData, setFormData] = useState(initialFormData);
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "phone" && !/^\d*$/.test(value)) {
      return;
    }
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleFormReset = () => {
    setFormData(initialFormData);
  };
  const handleEnquiry = async (e) => {
    e.preventDefault();
    if (!formData.captcha) {
      toast.error("Please complete the captcha", {
        style: {
          borderRadius: "10px",
          background: "#333",
          color: "#fff",
        },
      });
      return;
    }
    try {
      const body = JSON.stringify({
        email: formData.email,
        name: formData.name,
        message: formData.query,
        phone: formData.phone,
      });
      const api = `${BASEURL}/main/contactus/`;
      const response = await fetch(api, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: body,
      });
      if (response.ok) {
        const responseData = await response.json();
        toast.success(responseData.message, {
          style: {
            borderRadius: "10px",
            background: "#333",
            color: "#fff",
          },
        });
        handleFormReset();
        // Reset the reCAPTCHA
        if (recaptchaRef.current) {
          recaptchaRef.current.reset();
        }
      } else {
        throw new Error("Network response was not ok.");
      }
    } catch (error) {
      handleFormReset();
      toast.error("Error occurred while sending the query", {
        style: {
          borderRadius: "10px",
          background: "#333",
          color: "#fff",
        },
      });
      console.error("Error occurred while sending the query:", error);
    }
  };
  return (
    <div className="queries-container">
      <Container maxWidth="lg">
        <div className="contact-form">
          <div className="queries-left">
            <h3>
              Drop your <span style={{ color: "#e96c4c" }}>queries</span> here{" "}
            </h3>
            <p>
              and explore a world of <br />
              possibilities!
            </p>
          </div>
          <div className="queries-right">
            <form onSubmit={handleEnquiry}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    position: "relative",
                    width: "45%",
                  }}
                >
                  <span
                    style={{
                      position: "absolute",
                      left: "5px",
                      top: "50%",
                      transform: "translateY(-50%)",
                    }}
                  >
                    +91
                  </span>
                  <input
                    className="enquiry-input-box"
                    placeholder="Phone number"
                    required
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    maxLength={10}
                    pattern="[0-9]*"
                    style={{
                      width: "100%",
                      paddingLeft: "35px",
                      fontFamily: "Poppins",
                    }}
                  />
                </div>
                <input
                  required
                  type="text"
                  name="name"
                  onChange={handleChange}
                  value={formData.name || ""}
                  className="enquiry-input-box"
                  style={{ width: "45%", fontFamily: "Poppins" }}
                  placeholder="Your name"
                />
              </div>
              <input
                required
                name="email"
                onChange={handleChange}
                value={formData.email}
                className="enquiry-input-box"
                style={{
                  width: "100%",
                  marginTop: "1rem",
                  fontFamily: "Poppins",
                }}
                type="email"
                placeholder="Your email address"
              />
              <textarea
                required
                name="query"
                onChange={handleChange}
                value={formData.query || ""}
                className="enquiry-input-box"
                style={{
                  width: "100%",
                  marginTop: "1rem",
                  resize: "vertical",
                  fontFamily: "Poppins",
                  marginBottom: "1rem",
                }}
                placeholder="Your query"
              />
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey="6Ldq0jQpAAAAAFbW4Ky5pPVdtsEsm1MhZsHUDG3l"
                onChange={(value) =>
                  setFormData((prevData) => ({
                    ...prevData,
                    captcha: value,
                  }))
                }
              />
              <div>
                <button className="enquiry-button" type="submit">
                  Send Message
                </button>
              </div>
            </form>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Queries;
